import styled from "styled-components";

import { colors, fonts } from "../../../styles/variables";

const StyledCheckoutTotal = styled.div`
  margin-bottom: 20px;
  margin-top: 20px;
`;

const StyledCheckoutTotalItem = styled.div`
  &:not(:last-child) {
    margin-bottom: 10px;
  }
  display: flex;
  align-items: center;
`;

const StyledCheckoutTotalItemLeft = styled.span`
  margin-right: 20px;
  line-height: 1.45;
  display: inline-block;
  overflow: hidden;
  max-width: 242px;
`;

const StyledCheckoutTotalItemRight = styled.span`
  flex: 1;
  flex-shrink: 0;
  display: inline-block;
  text-align: right;
  font-size: 20px;
  font-family: ${fonts.fontInterstateBlackCompressed};
  white-space: nowrap;
`;

const StyledDiscountTotalItemLeft = styled(StyledCheckoutTotalItemLeft)`
  font-weight: bold;
`;

const StyledCheckoutTotalItemPrice = styled.span`
  display: inline-block;
  font-size: 16px;
  &:not(:first-child) {
    margin-left: 10px;
  }
`;

const StyledCheckoutTotalItemTitle = styled.span`
  font-size: 20px;
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  display: block;
  line-height: 1.2;
`;

const StyledCheckoutTotalItemTitlePrice = styled.span`
  font-size: 50px;
  font-family: ${fonts.fontInterstateBlackCompressed};
  line-height: 1;
`;

const StyledCheckoutTotalItemPriceBold = styled(StyledCheckoutTotalItemPrice)`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 20px;
`;

const StyledCheckoutTotalItemPriceBoldRed = styled(StyledCheckoutTotalItemPriceBold)`
  color: ${colors.danger};
`;

const StyledCheckoutValue = styled.span`
  min-width: 35px;
  display: inline-block;
`;

const StyledCheckoutDiscountValue = styled(StyledCheckoutValue)`
  color: ${colors.danger};
`;

const StyledCheckoutTotalItemWithInfoLabel = styled(StyledCheckoutTotalItem)`
  margin-bottom: 0px;
  &:not(:last-child) {
    margin-bottom: 0px;
  }
`;

const StyledCheckoutDiscountValueCrossed = styled.del`
  display: inline-block;
  font-size: 20px;
  font-family: ${fonts.fontInterstateBlackCompressed};
  color: ${colors.danger};
  min-width: 35px;
`;

const StyledCheckoutItemInfoLabel = styled.span`
  line-height: 1.2em;
  display: inline-block;
  overflow: hidden;
  font-size: 11px;
  margin-bottom: 10px;
`;

export {
  StyledCheckoutTotal,
  StyledCheckoutTotalItem,
  StyledCheckoutTotalItemLeft,
  StyledCheckoutTotalItemRight,
  StyledDiscountTotalItemLeft,
  StyledCheckoutTotalItemPrice,
  StyledCheckoutTotalItemTitle,
  StyledCheckoutTotalItemTitlePrice,
  StyledCheckoutTotalItemPriceBold,
  StyledCheckoutTotalItemPriceBoldRed,
  StyledCheckoutValue,
  StyledCheckoutDiscountValue,
  StyledCheckoutTotalItemWithInfoLabel,
  StyledCheckoutDiscountValueCrossed,
  StyledCheckoutItemInfoLabel,
};
